export default {
  de: {
    personType: {
      person: 'Person',
      factory: {
        slaughter: 'Schlachthof',
        factory: 'Betrieb'
      }
    },
    notification: {
      create: {
        type: 'success',
        message: 'Person erfolgreich angelegt',
        title: 'Erfolgreich angelegt'
      },
      update: {
        type: 'success',
        message: 'Person erfolgreich gespeichert',
        title: 'Erfolgreich gespeichert'
      }
    }
  }
}
